import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import logo from "../assets/icons/logo.png";
import clapperboard from "../assets/icons/clapperboard.png";
import clapperboardHover from "../assets/icons/made-with-love.png";
import { GiWorld } from "react-icons/gi";
import { AiFillHome, AiOutlineLogin, AiOutlineLogout } from "react-icons/ai";
import { AiOutlineMenuFold } from "react-icons/ai";
import "./LeftMenu.css";
import { IconButton, Tooltip } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import LeftMenuSmallScreen from "./LeftMenuSmallScreen";
import MadeWithLove from "./MadeWithLove";

export default function LeftMenu({ isSmallScreen, closeLeftMenu, isOpen }) {
  const [isHover, setIsHover] = useState(false);
  const [showMadeWithLove, setShowMadeWithLove] = useState(false);
  const { logout, loggedInUser } = useAuth();
  const navigate = useNavigate();
  if (isSmallScreen) {
    return (
      <LeftMenuSmallScreen
        loggedInUser={loggedInUser}
        logout={logout}
        closeLeftMenu={closeLeftMenu}
        navigate={navigate}
        logo={logo}
        isOpen={isOpen}
      />
    );
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          width: "70px",
          background: (theme) => theme.palette.primary.dark,
        }}
        className="md-leftMenu"
      >
        <CssBaseline />
        <NavLink to="/">
          <img src={logo} alt="prihaniway" width={30} className="md-logo" />
        </NavLink>

        {isSmallScreen && (
          <IconButton onClick={closeLeftMenu}>
            <AiOutlineMenuFold />
          </IconButton>
        )}
        <Box
          sx={{ display: "flex", flexDirection: "column" }}
          className="md-leftMenu-mainButton mainButton"
        >
          <IconButton sx={IconStyle}>
            <NavLink to="/">
              <AiFillHome />
            </NavLink>
          </IconButton>
          <IconButton sx={IconStyle}>
            <a href="https://pirhaniway.com/">
              <GiWorld />
            </a>
          </IconButton>
          <IconButton
            sx={IconStyle}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            onClick={() => setShowMadeWithLove(true)}
          >
            <img
              src={isHover ? clapperboardHover : clapperboard}
              alt="made with love"
              width={24}
              className="md-logoLove"
            />
          </IconButton>
        </Box>

        {loggedInUser?.username ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="logout">
              <IconButton sx={IconStyle} onClick={logout}>
                <AiOutlineLogout />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Tooltip title="login">
            <IconButton sx={IconStyle} onClick={() => navigate("/login")}>
              <AiOutlineLogin />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <MadeWithLove
        open={showMadeWithLove}
        handleClose={() => setShowMadeWithLove(false)}
      />
    </>
  );
}

export const IconStyle = {
  transition: "all 0.3s linear",
  color: (theme) => theme.palette.secondary.main,
  mt: 1,
  "&:hover": {
    color: (theme) => theme.palette.primary.light,
  },
  "&>a": {
    transition: "all 0.3s linear",
    color: (theme) => theme.palette.secondary.main,
  },
  "&>a:hover": {
    color: (theme) => theme.palette.primary.light,
  },
};
